import { Application } from '@hotwired/stimulus'
import StimulusReflex from 'stimulus_reflex'
import CableReady from 'cable_ready'
import consumer from '../channels/consumer'

const application = Application.start()

// Auto-register Stimulus controllers (Vite equivalent of require.context + definitionsFromContext)
const controllers = import.meta.glob('./**/*_controller.js', { eager: true })
for (const path in controllers) {
  const name = path
    .replace('./', '')
    .replace(/_controller\.js$/, '')
    .replace(/\//g, '--')
    .replace(/_/g, '-')
  if (controllers[path].default) {
    application.register(name, controllers[path].default)
  }
}

// Auto-register ViewComponent Stimulus controllers
const componentControllers = import.meta.glob(
  '../../components/**/*_controller.js',
  { eager: true }
)
for (const path in componentControllers) {
  let name = path
    .replace(/^.*components\//, '')
    .replace(/_controller\.js$/, '')
    .replace(/\//g, '--')
    .replace(/_/g, '-')

  // Remove redundant trailing segment if it matches the parent folder name
  const segments = name.split('--')
  if (
    segments.length > 1 &&
    segments[segments.length - 1] === segments[segments.length - 2]
  ) {
    segments.pop()
    name = segments.join('--')
  }

  if (componentControllers[path].default) {
    application.register(name, componentControllers[path].default)
  }
}

application.consumer = consumer

CableReady.initialize({ consumer })
StimulusReflex.initialize(application)
